module.exports = __webpack_public_path__ + "static/media/battery-half.568e2123.svg";